import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';
/**
 * SearchBox:
 *   - The wrapping component for Search in Glossary
 */
export function SearchBox(props) {
  return <div className={style.searchbox}>{props.children}</div>;
}

SearchBox.propTypes = {
  /**
   * Child components to be rendered in the searchBox
   *  - Possibly SearchInput and SearchIcon components.
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
};

SearchBox.defaultProps = {};
